import {BASE_URL} from 'appConstants';

import {get, post} from 'sdk';

export const fetchMyTeams = () => {
  const url = `${BASE_URL}/v1/permissions/teams/my/`;

  return get(url);
};

export const fetchAllTeams = ({extraGetParams}) => {
  const url = `${BASE_URL}/v1/permissions/teams/all/`;

  return get(url, extraGetParams);
};

export const fetchPermissionEntities = () => {
  const url = `${BASE_URL}/v1/permissions/entities/`;

  return get(url);
};

export const createTeam = ({name, avatar, locations, permissionEntities}) => {
  const url = `${BASE_URL}/v1/permissions/teams/create/`;
  const data = {name, avatar, locations, permissionEntities};

  return post(url, data);
};

export const teamAvatarSignOnCreate = ({filename, fileType}) => {
  const url = `${BASE_URL}/v1/permissions/teams/avatars/sign-on-create/`;
  const payload = {filename, fileType};

  return post(url, payload);
};

export const teamAvatarSignOnEdit = ({filename, fileType, team}) => {
  const url = `${BASE_URL}/v1/permissions/teams/avatars/sign-on-edit/`;
  const payload = {filename, fileType, team};

  return post(url, payload);
};

export const fetchStaffMembers = ({extraGetParams}) => {
  const url = `${BASE_URL}/v1/permissions/staff-members/`;

  return get(url, extraGetParams);
};

export const inviteNewStaffMember = ({name, email, jobTitle, teams}) => {
  const url = `${BASE_URL}/v1/permissions/staff-members/invite/`;
  const data = {name, email, jobTitle, teams};

  return post(url, data);
};

export const fetchStaffMember = ({memberId}) => {
  const url = `${BASE_URL}/v1/permissions/staff-members/${memberId}`;

  return get(url);
};

export const fetchTeamDetail = ({teamId}) => {
  const url = `${BASE_URL}/v1/permissions/teams/${teamId}/`;

  return get(url);
};

export const editTeamDetails = ({id, name, avatar}) => {
  const url = `${BASE_URL}/v1/permissions/teams/edit/`;

  return post(url, {team: id, name, avatar});
};

export const editTeamPermissions = ({
  teamId,
  possitivePermissionEntities,
  negativePermissionEntities
}) => {
  const url = `${BASE_URL}/v1/permissions/teams/edit-permissions/`;
  const data = {
    team: teamId,
    possitivePermissionEntities,
    negativePermissionEntities
  };

  return post(url, data);
};

export const fetchTeamPermissions = ({teamId}) => {
  const url = `${BASE_URL}/v1/permissions/teams/${teamId}/get-permissions/`;

  return get(url);
};

export const addMemberToTeam = ({teamId, memberId}) => {
  const url = `${BASE_URL}/v1/permissions/teams/members/add/`;

  return post(url, {team: teamId, members: [memberId]});
};

export const removeMemberFromTeam = ({teamId, memberId}) => {
  const url = `${BASE_URL}/v1/permissions/teams/members/remove/`;

  return post(url, {team: teamId, member: memberId});
};

export const demoteTeamOwner = ({teamId, memberId}) => {
  const url = `${BASE_URL}/v1/permissions/teams/members/demote-owner/`;

  return post(url, {team: teamId, teamOwner: memberId});
};

export const promoteTeamOwner = ({teamId, memberId}) => {
  const url = `${BASE_URL}/v1/permissions/teams/members/promote-member/`;

  return post(url, {team: teamId, member: memberId});
};

export const deleteTeam = ({teamId}) => {
  const url = `${BASE_URL}/v1/permissions/teams/delete/`;

  return post(url, {team: teamId});
};

export const removeTeamLocation = ({teamId, locationRef}) => {
  const url = `${BASE_URL}/v1/permissions/teams/locations/remove/`;

  return post(url, {team: teamId, location: locationRef});
};

export const addTeamLocation = ({teamId, locationRef}) => {
  const url = `${BASE_URL}/v1/permissions/teams/locations/add/`;

  return post(url, {team: teamId, locations: [locationRef]});
};

export const activateUser = ({userId}) => {
  const url = `${BASE_URL}/v1/users/activate/`;

  return post(url, {user: userId});
};

export const deactivateUser = ({userId}) => {
  const url = `${BASE_URL}/v1/users/deactivate/`;

  return post(url, {user: userId});
};

export const resendAdminInvitation = ({adminId}) => {
  const url = `${BASE_URL}/v1/users/admins/resend-invitation/`;

  return post(url, {admin: adminId});
};

export const resetAdminPassword = ({adminId}) => {
  const url = `${BASE_URL}/v1/users/admins/reset-password/`;

  return post(url, {admin: adminId});
};

export const setInactivityLogoutTimer = ({
  teamId,
  inactivityTimer,
  forceLogout
}) => {
  const url = `${BASE_URL}/v1/permissions/teams/set-inactivity-logout-timer/`;

  return post(url, {team: teamId, inactivityTimer, forceLogout});
};
